<template>
<div class="container">

  <!-- Outer Row -->
  <div class="row justify-content-center">

    <div class="col-xl-10 col-lg-12 col-md-9">

      <div class="card o-hidden border-0 shadow-lg my-5">
        <div class="card-body p-0">
          <!-- Nested Row within Card Body -->
          <div class="row">
            <div class="col-lg-6 d-none d-lg-block bg-login-image" v-bind:style="{ background: 'url(' + imgSrc + ')', backgroundPosition: 'center', backgroundSize: 'cover' }"></div>
            <div class="col-lg-6">
              <div class="p-5">
                <div class="text-center">
                  <h1 class="h4 text-gray-900 mb-4">Welcome Back!</h1>
                </div>
                <p class="text-danger text-center" v-if="hasError"><small>Combinaison email et mot de passe incorrecte.</small></p>
                <b-form class="user">
                  <b-form-group label-for="input-email">
                    <b-form-input id="input-email" v-model="email" type="email" required placeholder="Email..." class="form-control-user" :class="{'is-invalid': $v.email.$error}"></b-form-input>
                  </b-form-group>

                  <b-form-group label-for="input-pwd">
                    <b-form-input id="input-pwd" v-model="password" type="password" required placeholder="Mot de passe" class="form-control-user" :class="{'is-invalid': $v.password.$error}"></b-form-input>
                  </b-form-group>

                  <div class="text-center text-danger my-2" v-if="submitStatus == 'pending'">
                    <span aria-hidden="true" class="align-middle spinner-border"></span>
                    <strong>Loading...</strong>
                  </div>

                  <b-button v-else type="button" variant="primary" class="btn-user btn-block" @click.prevent="login">
                    Connexion
                  </b-button>

                </b-form>
                <!--
                <hr>
                <div class="text-center">
                  <a class="small" href="forgot-password.html">Forgot Password?</a>
                </div>
                -->
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
</template>

<script>
  import { required, minLength, email, sameAs } from "vuelidate/lib/validators"
  import axios from 'axios'

  export default {
    name: 'login',
    data() {
      return {
        email: '',
        password: '',
        submitStatus: '',
        hasError: false,
        imgSrc: require('@/assets/homebgv2.jpg'),
      }
    },
    validations: {
      email: {
        required,
        email
      },
      password: {
        required,
      },
    },
    methods: {
      login: function() {
        if(this.submitStatus != "pending") {
          this.submitStatus = 'pending'
          this.inputErrors = []

          this.$v.$touch()
          if (this.$v.$invalid) {
            console.log("error")
            this.submitStatus = ''
          } else {
            let email = this.email
            let password = this.password

            this.$store
              .dispatch('login', { email, password })
              .then((e) => {
                this.$router.push('/dashboard')
              })
              .catch(err => {
                this.hasError = true
                this.submitStatus = ''
              })
          }
        }

      },
      toggleBodyClass(addRemoveClass, className) {
        const el = document.body;
        if (addRemoveClass === 'addClass') {
          el.classList.add(className);
        } else {
          el.classList.remove(className);
        }
      },
    },
    mounted() {
      this.toggleBodyClass('addClass', 'bg-login');
    },
    destroyed() {
      this.toggleBodyClass('removeClass', 'bg-login');
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Login.vue